import React from 'react'

interface ProtectionModelProps {
    offer: any;
    onClose: () => void;
    right?: number;
}

const ProtectionModel: React.FC<ProtectionModelProps> = ({ offer, onClose, right }) => {

    const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };
    return (
        <div
            onClick={handleOverlayClick}
            style={{
                position: 'absolute',
                top: 100,
                left: 0,
                right: right ? right : 500,
                bottom: 0,
                // width:'30%',
                // height: 200,
                // backgroundColor: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000
            }}>
            <div
                onClick={(e) => e.stopPropagation()} // Prevent click events from reaching the overlay
                style={{
                    width: 300,
                    minHeight: '200',
                    maxHeight: '300',
                    overflow: 'auto',
                    backgroundColor: '#fff',
                    padding: '20px',
                    borderRadius: '5px',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                    textAlign: 'center'
                }}>
                {/* create messege for success from server */}

                <>

                    
                    {offer != null && offer.protectionTxt != null? <div className='right-align message-text' dangerouslySetInnerHTML={{ __html: offer.protectionTxt }}></div>: ""}
                </>
            </div>
        </div>
    )
}

export default ProtectionModel